import React from 'react';
import { IconProps } from '../types';
const MinecraftExperienceBottle: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="1" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(208, 228, 90, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(170, 228, 90, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(201, 255, 145, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(89, 176, 87, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(181, 228, 90, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(203, 255, 143, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(89, 176, 87, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(57, 144, 76, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(89, 176, 87, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(192, 228, 90, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(196, 255, 143, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(57, 144, 76, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(39, 117, 59, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(57, 144, 76, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(185, 228, 90, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(57, 144, 76, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(39, 117, 59, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(57, 144, 76, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(192, 255, 149, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(183, 228, 90, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(89, 176, 87, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(57, 144, 76, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(89, 176, 87, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(200, 255, 143, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(186, 228, 90, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(114, 176, 54, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(201, 255, 145, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(184, 228, 90, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(81, 60, 3, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(45, 33, 2, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(216, 228, 90, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
<rect x="10" y="15" width="1" height="1" fill="rgba(245, 255, 143, 255)" />
</svg>);
export default MinecraftExperienceBottle;